import {
  FETCH_ADVERTISER_DATE_QUARTER,
  FETCH_WOW_REQUEST,
  FETCH_WOW_DATE_ERROR,
  SET_SELECTED_WOW_QUARTERS,
  FETCHED_WOW_REPORT,
  FETCHED_WOW_REPORT_ERROR,
  RESET_WOW_DATA,
  SET_WOW_START_DATE,
  SET_WOW_END_DATE,
  SET_WOW_QUARTER_RANGES,
  CLEAR_WOW_LOADING
} from './wowTypes';

const initialState = {
  loading: false,
  advertiser_quarters: [],
  selected_advertiser_wow_quarters: [],
  wowReportData: [],
  error: [],
  wow_start_date: null,
  wow_end_date: null,
  wow_quarter_ranges: []
};
const WowReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_WOW_REQUEST:
      return {
        ...state,
        loading: true
      };
    case RESET_WOW_DATA: {
      return {
        ...state,
        // advertiser_quarters: [],
        // selected_advertiser_wow_quarters: [],
        wowReportData: [],
        error: []
      };
    }
    case FETCH_ADVERTISER_DATE_QUARTER:
      return {
        ...state,
        // loading: false,
        advertiser_quarters: action.payload,
        selected_advertiser_wow_quarters: action.payload
      };
    case FETCH_WOW_DATE_ERROR:
      return {
        ...state,
        loading: false,
        error_msg: 'Sorry no data found',
        error: action.payload,
        advertiser_quarters: [],
        selected_advertiser_wow_quarters: []
      };
    case SET_SELECTED_WOW_QUARTERS: {
      return {
        ...state,
        // loading: false,
        selected_advertiser_wow_quarters: action.payload.selected_wow_quarter
      };
    }
    case FETCHED_WOW_REPORT_ERROR: {
      return {
        ...state,
        loading: false,
        wowReportData: [],
        error_msg: 'Sorry no data found',
        error: action.payload
      };
    }
    case FETCHED_WOW_REPORT: {
      return {
        ...state,
        loading: false,
        wowReportData: action.payload
      };
    }
    case SET_WOW_START_DATE:
      return {
        ...state,
        wow_start_date: action.payload
      };
    case SET_WOW_END_DATE:
      return {
        ...state,
        wow_end_date: action.payload
      };
    case SET_WOW_QUARTER_RANGES:
      return {
        ...state,
        wow_quarter_ranges: action.payload // Array of {quarter, startDate, endDate}
      };
    case CLEAR_WOW_LOADING: {
      return {
        ...state,
        loading: false // ⭐ Clear loading
      };
    }
    default:
      return state;
  }
};
export default WowReducer;
